import React, { useEffect, useState } from 'react';
import './page.css';
import './table.css';
import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';
import { resolveDate } from '../../../../configs/helpers/utility';

const useStyles = makeStyles((theme) => ({
   card: {
      padding: '10px',
      border: 'solid red 1px',
   },
   descContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
   },
   loading: {
      height: '300px',
      width: '100%',
      backgroundColor: '#F2F2F2',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
   },
   graphsContainer: {
      width: '100%',
      display: 'flex',
   },
   usedPointFlag: {
      width: 10,
      height: 10,
      backgroundColor: '#EC068D',
      borderRadius: '2px',
   },
   remainPointFlag: {
      width: 10,
      height: 10,
      backgroundColor: '#CCCCCC',
      borderRadius: '2px',
   },
   tablesContainer: {
      height: '100%',
   },
}));

const PDFCSS = () => {
   const classes = useStyles();
   const [filtersData, setFiltersData] = useState();
   const [chartData, setChartData] = useState();
   const [tableData, setTableData] = useState();
   useEffect(() => {
      let report = localStorage.getItem('report');
      if (report) {
         let { filtersData, chartData, tableData } = JSON.parse(report);
         setFiltersData(filtersData);
         setChartData(chartData);
         setTableData(tableData);
         window.print();
      }
      return () => {
         localStorage.removeItem('report');
      };
   }, []);
   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };
   const getChartsOptionsDefault = () => {
      return {
         animation: false,
         animationDuration: 0,
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               type: 'shadow',
            },
         },
         legend: [
            {
               left: '18%',
               itemWidth: 50,
               itemGap: 15,
               data: [
                  'คะแนน for SOCIETY ที่ได้รับ',
                  'คะแนน with GOVERNANCE ที่ได้รับ',
                  'คะแนน through DIGITALIZATION ที่ได้รับ',
               ],
            },
            {
               top: 60,
               left: '18%',
               itemWidth: 50,
               itemGap: 20,
               data: [
                  'คะแนน for SOCIETY ที่แลก',
                  'คะแนน with GOVERNANCE ที่แลก',
                  'คะแนน through DIGITALIZATION ที่แลก',
               ],
            },
         ],
         grid: {
            left: '3%',
            right: '4%',
            bottom: '0%',
            top: '40%',
            containLabel: true,
         },
         xAxis: [
            {
               name: 'วัน',
               type: 'category',
               data: null,
            },
         ],
         yAxis: [
            {
               name: 'คะแนน',
               type: 'value',
            },
         ],
         series: [
            {
               color: '#EDD221',
               name: 'คะแนน for SOCIETY ที่ได้รับ',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#F383BB',
               name: 'คะแนน with GOVERNANCE ที่ได้รับ',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#633C21',
               name: 'คะแนน through DIGITALIZATION ที่ได้รับ',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#D1F2EB',
               name: 'คะแนน for SOCIETY ที่แลก',
               type: 'bar',
               stack: 'used',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#1ABC9C',
               name: 'คะแนน with GOVERNANCE ที่แลก',
               type: 'bar',
               stack: 'used',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#76D7C4',
               name: 'คะแนน through DIGITALIZATION ที่แลก',
               type: 'bar',
               stack: 'used',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
         ],
      };
   };
   const mapOptions = (data) => {
      let xAxisData = data.map((el) => el.dateTimeLabel.split(' ')[0]);
      let G = data.map((el) => el.gTotalReceived);
      let S = data.map((el) => el.sTotalReceived);
      let B = data.map((el) => el.bTotalReceived);
      let GRedeem = data.map((el) => el.gTotalRedeem);
      let SRedeem = data.map((el) => el.sTotalRedeem);
      let BRedeem = data.map((el) => el.bTotalRedeem);
      let options = getChartsOptionsDefault();
      options.xAxis[0].data = xAxisData;
      options.series[0].data = G;
      options.series[1].data = S;
      options.series[2].data = B;
      options.series[3].data = GRedeem;
      options.series[4].data = SRedeem;
      options.series[5].data = BRedeem;
      return options;
   };
   return (
      <div className='book'>
         <div className='page' id='1'>
            <div className='    '>
               <div className='title'>
                  ความถี่ของคะแนนที่พนักงานได้รับและการแลกของรางวัล
               </div>
               <div className='sub-title'>ตัวกรอง</div>
               <div>
                  <div>
                     กลุ่ม:{' '}
                     {(filtersData &&
                        filtersData.group &&
                        filtersData.group.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     สายงาน:{' '}
                     {(filtersData &&
                        filtersData.field &&
                        filtersData.field.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     ฝ่าย/ภาค:{' '}
                     {(filtersData &&
                        filtersData.department &&
                        filtersData.department.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     ส่วน/เขต:{' '}
                     {(filtersData &&
                        filtersData.segment &&
                        filtersData.segment.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     งาน/สาขา:{' '}
                     {(filtersData &&
                        filtersData.branch &&
                        filtersData.branch.data.shortName) ||
                        '-'}
                  </div>
                  <div>
                     เริ่มต้น:{' '}
                     {(filtersData &&
                        resolveDate(filtersData.startDateString)) ||
                        '-'}
                  </div>
                  <div>
                     สิ้นสุด:{' '}
                     {(filtersData && resolveDate(filtersData.endDateString)) ||
                        '-'}
                  </div>
               </div>
               <div className='sub-title'>กราฟ</div>
               <div className={classes.graphsContainer}>
                  {chartData && (
                     <ReactECharts
                        option={mapOptions(chartData)}
                        style={{ height: 400, width: '100%' }}
                     />
                  )}
               </div>
               <div className='sub-title'>Top 10 ของรางวัลที่ถูก Redeem</div>
               <div>
                  {tableData && (
                     <div>
                        <div className='title'>{tableData.name}</div>
                        <table className='leaderboard'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>รางวัล</th>
                              <th>ประเภทของรางวัล</th>
                              <th>จำนวนที่แลก</th>
                           </tr>
                           {tableData.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.rewardNameTh}</td>
                                 <td>{item.categoryNameTh}</td>
                                 <td class='text-right'>
                                    {costFormat(item.qty)}
                                 </td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default PDFCSS;
